import React, { useCallback, useMemo } from "react";
import { residentsCreator } from "../../redux/residents/selectors";
import { DeviceType } from "../../redux/devices";
import { IAppState } from "../../redux/types";
import { useSelector } from "react-redux";
import { userNearbyStatusCreator } from "../../redux/devicesStatuses/selectors";
import { findTimetoShow } from "../status/utils";
import { OverflowTip } from "../common/Common";
import { AvatarResidentUser, UnknowUser } from "../common/AvatarUser";
import { Skeleton } from "@material-ui/lab";
import { langByLocal } from "../../utils/Languages";
import { usersByIdCreator, usersReady } from "../../redux/users/selectors";
import { UserNearbyStatus } from "../../redux/devicesStatuses";
import { useTranslation } from "react-i18next";
import { ModalTypes } from "../status/Callbacks";

const UserNearbyRoomStatus = ({
  residentId,
  callback,
}: {
  residentId: string;
  callback: (...args: any) => void;
}) => {
  const { t } = useTranslation("common");
  const onClose = useCallback(() => {
    callback(ModalTypes.BACK);
  }, [callback]);
  const ResidentSelection = useMemo(() => residentsCreator(), []);
  const resident = useSelector((state: IAppState) =>
    ResidentSelection(state, residentId)
  );
  const vitalsId = Object.keys(resident.devicesMinimized).find(
    (el) => resident.devicesMinimized[el].type === DeviceType.vitals
  );
  const userNearby = useMemo(() => userNearbyStatusCreator(), []);
  const userNearbyStatus = useSelector((state: IAppState) =>
    userNearby(state, vitalsId)
  );
  return (
    <div className="resident-status-holder">
      <div className="resident-status" style={{ display: "flex" }}>
        <div className="flex-column flex-center flex-column-16 full-width ">
          <p>{t("status:nearRoomStatus")}</p>
          <div className="flex-column flex-center full-width ">
            <UserNeabyRoomWithTooltip userNearbyStatus={userNearbyStatus} />
          </div>
          <button
            className="btn secondary  with-icon save-view"
            onClick={onClose}
          >
            <i className="icon-close" />
            {t("buttons.Close")}
          </button>
        </div>
      </div>
    </div>
  );
};
const UserNeabyRoomWithTooltip = ({
  userNearbyStatus,
}: {
  userNearbyStatus: UserNearbyStatus;
}): JSX.Element => {
  const { t } = useTranslation("status");
  const memoUsers = useMemo(() => usersByIdCreator(), []);
  const exist = userNearbyStatus?.nearRoom?.filter((el) => el.id);
  const users = useSelector((state: IAppState) =>
    memoUsers(
      state,
      exist.map((el) => el.id)
    )
  );
  const usersLoaded = useSelector(usersReady);
  const { language } = useSelector((state: IAppState) => state.userProfile);
  const lang = langByLocal(language);
  return (
    <div className="flex-column flex-center flex-column-16 full-width ">
      <p className="text-size-14">{t("User nearby")}</p>

      {userNearbyStatus?.nearRoom.map((el, index) => {
        const thisUser = users[index];
        return (
          <div
            className="flex-between one-user"
            key={el.id + el?.datetime + index}
          >
            <div className="flex-column">
              <div className="text-avatar flex-gap">
                {usersLoaded ? (
                  <>
                    {thisUser ? (
                      <AvatarResidentUser profile={thisUser} size="24" />
                    ) : (
                      <UnknowUser showName={true} />
                    )}
                  </>
                ) : (
                  <Skeleton variant="circle" width={32} height={32} />
                )}

                {usersLoaded && thisUser ? (
                  <OverflowTip
                    text={[thisUser?.firstName, thisUser?.lastName].join(" ")}
                    className="text-size-12"
                  />
                ) : (
                  <Skeleton variant="rect" width={80} height={14} />
                )}
              </div>
              {el?.alert && (
                <span
                  style={{ color: "#F5B66B", marginRight: "auto" }}
                  className="heebo-m text-size-10"
                >
                  {" "}
                  {t("continuous detection")}
                </span>
              )}
            </div>
            <span className="text-size-12 time-show">
              {findTimetoShow(el.datetime, lang)}
            </span>
          </div>
        );
      })}
    </div>
  );
};
export default React.memo(UserNearbyRoomStatus);
